import React from 'react';
import { Field } from 'formik';

import InputField from '../Form/FormInputField';
import Input from '../Form/FormInput';
import Label from '../Form/FormLabel';
import Error from '../Form/FormError';

const TextInput = ({ name, label, handlePaste, ...rest }) => (
  <Field
    name={name}
    render={({ field, form }) => {
      const error = form.touched[name] && form.errors[name];
      const valid = form.touched[name] && form.errors[name] === undefined && form.initialValues[name] !== form.values[name]
      return (
        <InputField>
          <Label htmlFor={name}>{label}</Label>
          <Input error={error} valid={valid} onPaste={handlePaste} {...field} {...rest} />
          {form.errors[name] && form.touched[name] && (
            <Error error={error}>{form.errors[name]}</Error>
          )}
        </InputField>
      );
    }}
  />
);

export default TextInput;


// WEBPACK FOOTER //
// ./src/components/Form/TextInputUX.js